import TermPageContent from '../../../components/TermPageContent/TermPageContent';
import ZPALayout from '../../../components/ZPALayout/ZPALayout';
import { buildPrimaryTermPage } from '../../../util/buildPrimaryTermPage';

const { getStaticProps, getStaticPaths, WrappedPage } =
    await buildPrimaryTermPage({
        basePath: '/premier-agent/category',
        site: 'ZPA',
        taxonomy: 'CATEGORY',
        LayoutComponent: ZPALayout,
        ContentComponent: TermPageContent,
        additionalLayoutProps: {
            isBlog: true,
        },
        menuPropName: 'submenu',
    });

export { getStaticProps, getStaticPaths };
export default WrappedPage;
